export default __webpack_public_path__ + "static/media/token_bottom_mobile.e2aaecad.png";